<template>
	<div class="container">
		<loader v-show="pageLoader"></loader>
		<div class="row justify-content-center"  >
			<div class="col-12 col-lg-6">
				<div class="api-accesss-tocken">
					<div class="modPic">
						<img src="../../../../static/website/images/Placeholder-pana.svg" alt="icon">
					</div>
					<div >
						<div class="d-flex align-items-end">
							<div class="form-group mb-0 w-100">
								<label class="getToken">Label</label>
								<div class="position-relative">
									<input class="form-control" type="text" placeholder="Hidden for security reasons" name="text" v-model="label" readonly v-if="update == false"/>
									<input class="form-control" type="text" placeholder=" " name="text"   v-model="label" v-else />
								</div>
							</div>
						</div>
						<div class="d-flex align-items-end">
							<div class="form-group mb-0 w-100">
								<label class="getToken">Url </label>
									<div class="position-relative">
									<input class="form-control" type="text" placeholder="Hidden for security reasons" name="text" v-model="url" readonly v-if="update == false"/>
									<input class="form-control" type="text" placeholder=" " name="text" v-model="url"  v-else />
								</div>
							</div>
							
						</div>
						<div class="genrateNew_show d-flex text-left mt-3" v-if="update == true">
							<a class="cap_btn blue justify-content-center d-flex align-items-center" href="#" @click="updateFunc()"><feather size="16px" type="eye" class="mr-1"></feather> Submit</a>
						</div>
					</div>
					<div class="genrateNew text-left mt-3">
					   <!--  <a class="cap_btn blue justify-content-center d-flex align-items-center" href="#">Generate New Api Key</a> -->
					   <p>If you want to update webhook please click here  <a href="#" @click="update = true">Update</a> </p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'wallets',
		data() {
			return {
				pageLoader : false,
				update : false,
				
			}
		},
		props:['label','url'],
		methods:{
			clear(){				
				this.update = false
				
			},
			updateFunc(){
				const _that = this
	            _that._runUpdateApiWebook(
					{ 'globalParams' :{ 
						webhook_label : _that.label,
						webhook_url   : _that.url
					},'localParams' :{"parameter" : _that}}
				)
			}
		},
		created(){
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/website/api-access/web_book.vue